"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var fuse_js_1 = __importDefault(require("fuse.js"));
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var mobx_1 = require("mobx");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var BASE_CLASS_NAME = "user-filter";
var UserFilter = (function (_super) {
    __extends(UserFilter, _super);
    function UserFilter() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getAvailableUsers = function (searchTerm) {
            var _a = _this.props, userList = _a.userList, selectedUserIds = _a.selectedUserIds;
            var unselectedUsers = userList.filter(function (u) { return !selectedUserIds.includes(u._id); });
            if (userList.length === 1) {
                return [];
            }
            var availableUsers = unselectedUsers;
            if (searchTerm) {
                var options = {
                    keys: ["firstName", "lastName", "email"],
                    threshold: 0.7,
                };
                var fuse = new fuse_js_1.default(unselectedUsers, options);
                availableUsers = fuse.search(searchTerm).map(function (result) { return result.item; });
            }
            return availableUsers.map(function (user) { return ({ value: user._id, label: user.email, data: user }); });
        };
        _this.inviteOtherPeople = function () {
            _this.props.$state.go("settings", { section: "users" });
        };
        return _this;
    }
    Object.defineProperty(UserFilter.prototype, "selectedUsers", {
        get: function () {
            var _a = this.props, userList = _a.userList, selectedUserIds = _a.selectedUserIds;
            return userList.filter(function (u) { return selectedUserIds.includes(u._id); });
        },
        enumerable: false,
        configurable: true
    });
    UserFilter.prototype.render = function () {
        var _this = this;
        var userList = this.props.userList;
        var noEntriesMessage = userList.length === 1 ? (react_1.default.createElement("p", { className: "".concat(BASE_CLASS_NAME, "__empty-state") },
            "You\u2019re the only one here!",
            react_1.default.createElement("br", null),
            react_1.default.createElement(kaleidoscope_2.Link, { onClick: this.inviteOtherPeople }, "Invite other people"),
            " to join your team")) : ("No matching users found");
        return (react_1.default.createElement("div", { className: BASE_CLASS_NAME, onClick: function (event) { return event.stopPropagation(); } },
            react_1.default.createElement(kaleidoscope_2.Combobox, { clearOnSelect: true, className: "".concat(BASE_CLASS_NAME, "__combobox"), label: "Search users by name or email", placeholder: "Enter a Name or Email", size: kaleidoscope_2.TextInputSize.Medium, entries: this.getAvailableUsers, onSelect: function (entry) { return _this.selectUser(entry.value); }, renderEntry: function (entry) { return react_1.default.createElement(kaleidoscope_1.UserCard, { className: "".concat(BASE_CLASS_NAME, "__entry"), user: entry.data }); }, noEntriesMessage: noEntriesMessage, noResultsMessage: noEntriesMessage }),
            this.renderSelectedUsers()));
    };
    UserFilter.prototype.renderSelectedUsers = function () {
        var _a;
        var _this = this;
        var className = "".concat(BASE_CLASS_NAME, "__selected-users");
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, (_a = {},
                _a["".concat(className, "--overflow")] = this.selectedUsers.length > 1,
                _a)) }, this.selectedUsers.map(function (user) { return (react_1.default.createElement(kaleidoscope_1.UserCard, { key: user._id, user: user },
            react_1.default.createElement(kaleidoscope_2.IconButton, { "aria-label": "Remove user from filter", size: kaleidoscope_2.ButtonSize.Small, icon: react_1.default.createElement(icons_1.Close, null), className: "".concat(BASE_CLASS_NAME, "__remove-click-target"), onClick: function () { return _this.deselectUser(user._id); } }))); })));
    };
    UserFilter.prototype.selectUser = function (userId) {
        var _a = this.props, selectedUserIds = _a.selectedUserIds, setSelectedUserIds = _a.setSelectedUserIds;
        setSelectedUserIds(selectedUserIds.concat(userId));
    };
    UserFilter.prototype.deselectUser = function (userId) {
        var _a = this.props, selectedUserIds = _a.selectedUserIds, setSelectedUserIds = _a.setSelectedUserIds;
        setSelectedUserIds(selectedUserIds.filter(function (uid) { return uid !== userId; }));
    };
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], UserFilter.prototype, "selectedUsers", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], UserFilter.prototype, "selectUser", null);
    UserFilter = __decorate([
        mobx_react_1.observer
    ], UserFilter);
    return UserFilter;
}(react_1.default.Component));
exports.default = UserFilter;
